


































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import StaffListItem from "@/components/StaffListItem.vue";

import ProjectManagerTableItem from "../viewmodels/project-manager-table-item";
import ProjectManagerTable from "@/components/project/ProjectManagerTable.vue";
import ProjectWorkerTable from "@/components/project/ProjectWorkerTable.vue";
import ProjectWorkerTableItem from "@/viewmodels/project-worker-table-item";

import UserListHeader from "@/components/UserListHeader.vue";
import VInviteModal from "../components/VInviteModal.vue";
import ProjectManagerSelect from "@/templates/ProjectManagerSelect.vue";
import ProjectManagerTableItemDecorator from "@/decorators/project-manager-table-item-decorator";
import ProjectWorkerTableItemDecorator from "@/decorators/project-worker-table-item-decorator";
import ProjectManager from "@/entities/project-manager";
import ProjectWorker from "@/entities/project-worker";

import { ProjectManagerInteractor } from "@/interactors/project-manager-interactor";
import { VuexProjectManagerPresenter } from "@/presenters/project-manager-presenter";
import ProjectManagerApi from "../api/gateways/project-manager-api";

import { ProjectWorkerInteractor } from "@/interactors/project-worker-interactor";
import { VuexProjectWorkerPresenter } from "@/presenters/project-worker-presenter";
import ProjectWorkerApi from "../api/gateways/project-worker-api";
import ProjectDetails from "../components/project/ProjectDetails.vue";
import SelectProjectWorkers from "../components/project/SelectProjectWorkers.vue";

@Component({
  components: {
    ProjectDetails,
    ProjectManagerTable,
    ProjectWorkerTable,
    UserListHeader,
    VInviteModal,
    StaffListItem,
    ProjectManagerSelect,
    SelectProjectWorkers
  }
})
export default class ProjectDetailsPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  editMode = false;
  selectedMemberIds = [];

  // 招待するユーザー
  worker = {
    id: 0,
    name: "",
    tel: "",
    email: ""
  };

  get project(): Project | null {
    return this.$store.state.project;
  }

  get editable(): boolean {
    return this.permissions.includes("project/project_operation");
  }

  get managerTable() {
    return {
      selectedIds: this.selectedMemberIds,
      items: this.unassignedManagerItems
    };
  }

  get assignedManagerItems(): ProjectManagerTableItem[] {
    return this.assignedManagers.map(ProjectManagerTableItemDecorator);
  }

  get unassignedManagerItems(): ProjectManagerTableItem[] {
    return this.unassignedManagers.map(ProjectManagerTableItemDecorator);
  }

  get workerTable() {
    return {
      selectedIds: this.selectedMemberIds,
      items: this.unassignedWorkerItems
    };
  }

  get assignedWorkerItems(): ProjectWorkerTableItem[] {
    return this.assignedWorkers.map(ProjectWorkerTableItemDecorator);
  }

  get unassignedWorkerItems(): ProjectWorkerTableItem[] {
    return this.unassignedWorkers.map(ProjectWorkerTableItemDecorator);
  }

  edit() {
    const params = { projectId: this.projectId };
    this.$router.push({ name: "project-edit", params });
  }

  // まとめて管理者にする
  async assignManagers() {
    this.managerInteractor.assignAll(this.selectedMemberIds);
  }

  async unassignManager(id: number) {
    this.managerInteractor.unassign(id);
  }

  // まとめて招待する
  async assignWorkers() {
    this.workerInteractor.assignAll(this.selectedMemberIds);
  }

  async unassignWorker(id: number) {
    await this.workerInteractor.unassign(id);
  }

  // 招待前の確認
  confirmInviteWorker(id: number) {
    const worker = this.unassignedWorkers.find(w => w.id === id);
    if (!worker) return;
    this.worker = worker;
    this.$nextTick(() => {
      (this.$refs.inviteModal as any).show();
    });
  }

  // 招待の本体
  async inviteWorker() {
    if (!this.worker) return;
    try {
      this.workerInteractor.assign(this.worker.id);
    } catch (e) {
      alert(e);
    }
  }

  /* Store */

  private get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  private get assignedManagers(): ProjectManager[] {
    return this.$store.getters["member/assigned-managers"];
  }

  private get unassignedManagers(): ProjectManager[] {
    return this.$store.getters["member/unassigned-managers"];
  }

  private get assignedWorkers(): ProjectWorker[] {
    return this.$store.getters["member/assigned-workers"];
  }

  private unassignedWorkers: ProjectWorker[] = [];

  async unassignedWorkerModalOpened() {
    this.changeUnassignedWorkerModalFilter(1);
  }

  async changeUnassignedWorkerModalFilter(type: 1 | 2) {
    const api = new ProjectWorkerApi(
      this.$store.getters.api,
      Number(this.projectId)
    );
    if (type === 1) {
      this.unassignedWorkers = await api.unassignedAndFavorite();
    }
    if (type === 2) {
      this.unassignedWorkers = await api.unassigned();
    }
    this.workerFilterType = type;
    this.selectedMemberIds = [];
  }

  /* Model */

  private get managerInteractor() {
    return new ProjectManagerInteractor(
      new VuexProjectManagerPresenter(this.$store),
      new ProjectManagerApi(this.$store.getters.api, Number(this.projectId))
    );
  }

  private get workerInteractor() {
    return new ProjectWorkerInteractor(
      new VuexProjectWorkerPresenter(this.$store),
      new ProjectWorkerApi(this.$store.getters.api, Number(this.projectId))
    );
  }

  workerFilterType = 1;
  workerOptions = [
    { text: "お気に入りのみ", value: 1 },
    { text: "全て", value: 2 }
  ];
}
